<div mat-dialog-title class="title">Encaminhar mensagem</div>
<mat-dialog-content
  ><app-search
    [placeholder]="'Pesquise por canal de atendimento'"
    (search)="search($event)"
  ></app-search>
  <mat-list class="rooms">
    <mat-list-item
      class="room"
      [ngClass]="{ selected: item.id === selected?.id }"
      *ngFor="
        let item of data.rooms | arrayFilterCallback : filterByName : nameFilter
      "
      (click)="select(item)"
    >
      <div class="room-item">
        <div class="item-icon">
          <span class="material-icons icon-business"> business </span>
        </div>
        {{ item.name }}
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="center">
  <button mat-raised-button mat-dialog-close tabindex="-1" class="bt-cancel">
    Cancelar
  </button>
  <button
    mat-raised-button
    [mat-dialog-close]="selected"
    class="bt-ok"
    [ngClass]="{ 'opacity-05': !selected }"
    [disabled]="!selected"
  >
    Encaminhar
  </button>
</mat-dialog-actions>
